import '../../css/home/index.scss';

$(function() {

    imagesLoaded("html, body", function() {
        //kv
        tween = new TimelineMax({ delay: .5 })
            .from('.kv_maintitle_tw', .8, { y: 50, opacity: 0, ease: Quart.easeOut })
            .from('.kv_maintitle_en', .8, { y: 50, opacity: 0, ease: Quart.easeOut }, '-=.6')
    });


    let tween;
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({ triggerElement: "#trigger_hamburger_dark", triggerHook: 0 })
        .setClassToggle(".hamburger_link", "dark")
        .addTo(controller);

    //關於校史館
    tween = new TimelineMax()
        .from('.about_pic', .8, { x: -100, opacity: 0, ease: Quart.easeOut })
        .from('.about_caption', .8, { x: 100, opacity: 0, ease: Quart.easeOut }, '-=.6')

    new ScrollMagic.Scene({ triggerElement: ".about_sec", triggerHook: 0.7 })
        .setTween(tween)
        .addTo(controller);


    new ScrollMagic.Scene({ triggerElement: ".collapse_txtcrawl", triggerHook: 0.1 })
        .setPin(".collapse_txtcrawl")
        .addTo(controller);

    new ScrollMagic.Scene({ triggerElement: ".member_sec", triggerHook: 0.5 })
        .setClassToggle(".collapse_txtcrawl", "hidden")
        .addTo(controller);

    tween = TweenMax.from('.btn_backtotop', .3, { opacity: 0, ease: Power1.easeOut })
    new ScrollMagic.Scene({ triggerElement: ".about_sec", triggerHook: 0.1 })
        .setTween(tween)
        .addTo(controller);

    tween = TweenMax.to('.btn_backtotop img', .2, { opacity: 0, ease: Power1.easeOut })
    new ScrollMagic.Scene({ triggerElement: ".footer", triggerHook: 0.9 })
        .setTween(tween)
        .addTo(controller);

    $('.btn_backtotop_link').click(function() {
        TweenMax.to('html,body', 1, { scrollTop: 0, ease: Quart.easeOut })
    });


    //開闔
    let _o;
    let _this;
    let $collapse_handler = $('.collapse_handler');

    $('.collapse_content').slideUp(0);
    $collapse_handler.attr('o', 0);

    $collapse_handler.click(function() {
        _this = $(this);
        _o = _this.attr('o');
        if (_o == 0) {
            _this.parent().find('.collapse_content').slideDown();
            _this.attr('o', 1);
            _this.addClass('active');
        } else {
            _this.parent().find('.collapse_content').slideUp();
            _this.attr('o', 0);
            _this.removeClass('active');
        }
    });


    //swiper ------------------------------------------
    let $swiper;
    let container;
    let pagination;
    let button_next;
    let button_prev;

    if ($(".swiper_slide_1").length > 0) {

        $swiper = '.swiper_slide_1';
        container = $swiper + ' .swiper';
        pagination = $swiper + ' .swiper-pagination';
        button_next = $swiper + ' .swiper-button-next';
        button_prev = $swiper + ' .swiper-button-prev';

        new Swiper(container, {
            grabCursor: true,
            slidesPerView: 1,
            // loop: true,
            // loopedSlides: 6,
            speed: 600,
            autoplay: {
                delay: 2000,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            navigation: {
                nextEl: button_next,
                prevEl: button_prev,
            },
            a11y: {
                enabled: true,
                firstSlideMessage: "第一則",
                lastSlideMessage: "最後一則",
                paginationBulletMessage: "到第 {{index}} 則",
            },
            breakpoints: {
                320: {
                    slidesPerView: 2,
                },
                950: {
                    slidesPerView: 1,
                }
            }
        });
    }

    if ($(".swiper_slide_2").length > 0) {

        $swiper = '.swiper_slide_2';
        container = $swiper + ' .swiper';
        pagination = $swiper + ' .swiper-pagination';
        button_next = $swiper + ' .swiper-button-next';
        button_prev = $swiper + ' .swiper-button-prev';

        new Swiper(container, {
            grabCursor: true,
            slidesPerView: 1,
            loop: true,
            loopedSlides: 1,
            speed: 600,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: pagination,
                clickable: true,
            },
            navigation: {
                nextEl: button_next,
                prevEl: button_prev,
            },
            a11y: {
                enabled: true,
                firstSlideMessage: "第一則",
                lastSlideMessage: "最後一則",
                paginationBulletMessage: "到第 {{index}} 則",
            },
        });
    }

    if ($(".swiper_posts").length > 0) {

        $swiper = '.swiper_posts';
        container = $swiper + ' .swiper';
        pagination = $swiper + ' .swiper-pagination';
        button_next = $swiper + ' .swiper-button-next';
        button_prev = $swiper + ' .swiper-button-prev';

        new Swiper(container, {
            grabCursor: true,
            slidesPerView: 1,
            // loop: true,
            // loopedSlides: 3,
            speed: 600,
            // autoplay: {
            //     delay: 3000,
            // },
            pagination: {
                el: pagination,
                clickable: true,
            },
            navigation: {
                nextEl: button_next,
                prevEl: button_prev,
            },
            a11y: {
                enabled: true,
                firstSlideMessage: "第一則",
                lastSlideMessage: "最後一則",
                paginationBulletMessage: "到第 {{index}} 則",
            },
        });
    }
});